import { render } from "./WildBookObserveLocation.vue?vue&type=template&id=7dac3956&scoped=true&ts=true"
import script from "./WildBookObserveLocation.vue?vue&type=script&lang=ts"
export * from "./WildBookObserveLocation.vue?vue&type=script&lang=ts"

import "./WildBookObserveLocation.vue?vue&type=style&index=0&id=7dac3956&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dac3956"]])

export default __exports__